import React from 'react';
import PropTypes from 'prop-types';

import { ExternalLink } from 'core/routing';

import { ChinaLinkStyled } from 'apps/components/footer/footer.styled';

const ChinaICP = props =>
  !props.chinaMode ? null : (
    <ChinaLinkStyled
      mobile={props.mobile}
      main={props.main}
      hiddenMediumToLarge={props.hiddenMediumToLarge}
    >
      <ExternalLink to='http://www.beian.miit.gov.cn'>
        {'蜀ICP备19003385号'}
      </ExternalLink>
    </ChinaLinkStyled>
  );

ChinaICP.propTypes = {
  chinaMode: PropTypes.bool,
  mobile: PropTypes.bool,
  main: PropTypes.bool,
  hiddenMediumToLarge: PropTypes.bool,
};

export default ChinaICP;
